var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65617 0.78125V2.15937C10.953 2.35625 12.7905 3.93125 13.5124 6.03125H2.42179C3.20929 3.93125 5.04679 2.35625 7.34367 2.15937V0.78125C7.34367 0.3875 7.60617 0.125 7.99992 0.125C8.39367 0.125 8.65617 0.3875 8.65617 0.78125ZM15.2188 8.65624V14.5625H15.875V15.875H0.125V14.5625H0.78125V8.65624H0.125V7.34374H15.875V8.65624H15.2188ZM11.9375 14.5625H13.9062V8.65624H11.9375V14.5625ZM8.65633 8.65624H10.6251V14.5625H8.65633V8.65624ZM5.37492 14.5625H7.34367V8.65624H5.37492V14.5625ZM2.09375 8.65624H4.0625V14.5625H2.09375V8.65624Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructure);
export default __webpack_public_path__ + "static/media/structure.6b897391.svg";
export { ForwardRef as ReactComponent };